var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.41 0.486389L6 4.88319L10.59 0.486389L12 1.83999L6 7.59999L0 1.83999L1.41 0.486389Z",
  fill: "#4585FF"
})));
export default SvgArrow;